/* eslint-disable no-unused-vars */
import { get, post, put } from "../config";

export function GetProduct() {
  return post({ url: `/api/aunjai/product` });
}

export function GetProductDetail({ product_id }) {
  return post({ url: `/api/aunjai/productDetail`, body: { product_id } });
}
